import { ActionResponse } from 'src/app/models/action-response';
import { BillingItem } from 'src/app/models/billingitem';
import { AddServiceTopackageDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/add-service-topackage-wizard/activation-step/addservices-due-date-info';
import { AddServiceTopackageInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/add-service-topackage-wizard/init-step/init-step';

export interface State {
  initStep: AddServiceTopackageInitStepV26;
  dueDatesStep: AddServiceTopackageDueDatesV26;
  servicesStep: BillingItem[];
  // request: ServiceParticularRequest;
  response: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  initStep: null,
  dueDatesStep: { activationDate: null, deactivationDate: null },
  servicesStep: null,
  response: null,
  errorMessage: null,
};
